// src/components/Hero.js
import React from "react";

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-bg"></div>
      <div className="hero-grid-pattern"></div>

      <div className="hero-container">

        {/* Left Content */}
        <div className="hero-content">
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            Now Expanding into Digital Marketing
          </div>

          <h1 className="hero-title">
            We Build Your <span className="gradient-text">Digital Future</span>{" "}
            &amp; <span className="accent-text">Data Empire</span>
          </h1>

          <p className="hero-desc">
            MechFolks Technologies delivers world-class <strong>Data Engineering</strong>,{" "}
            <strong>Web Development</strong>, and <strong>Digital Marketing</strong> solutions
            for startups and enterprises looking to scale and dominate in the digital era.
          </p>

          <div className="hero-tags">
            <span className="hero-tag">⚡ Data Engineering</span>
            <span className="hero-tag">🌐 Web Development</span>
            <span className="hero-tag">📈 Digital Marketing</span>
            <span className="hero-tag">📱 Mobile Apps</span>
          </div>

          <div className="hero-actions">
            <a href="#contact" className="btn-primary">
              Get a Free Quote &nbsp;→
            </a>
            <a href="#services" className="btn-secondary">
              Explore Services
            </a>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <h2>5+</h2>
              <p>Years Experience</p>
            </div>
            <div className="stat-item">
              <h2>10+</h2>
              <p>Projects Delivered</p>
            </div>
            <div className="stat-item">
              <h2>3</h2>
              <p>Core Services</p>
            </div>
          </div>
        </div>

        {/* Right Visual */}
        <div className="hero-visual">
          <div className="hero-card-main">
            <div className="hero-card-header">
              <div className="hero-card-avatar">🚀</div>
              <div>
                <h4>MechFolks Dashboard</h4>
                <p>Live project insights</p>
              </div>
            </div>

            <div className="hero-card-metrics">
              <div className="metric-box">
                <div className="metric-val">98%</div>
                <div className="metric-label">Client Satisfaction</div>
              </div>
              <div className="metric-box">
                <div className="metric-val">3x</div>
                <div className="metric-label">Faster Delivery</div>
              </div>
            </div>

            <div className="hero-card-bar">
              <p><span>Web Development</span><span>92%</span></p>
              <div className="bar-track"><div className="bar-fill" style={{width:"92%"}}></div></div>
              <p><span>Data Engineering</span><span>88%</span></p>
              <div className="bar-track"><div className="bar-fill" style={{width:"88%"}}></div></div>
              <p><span>Digital Marketing</span><span>85%</span></p>
              <div className="bar-track"><div className="bar-fill" style={{width:"85%"}}></div></div>
            </div>
          </div>

          <div className="floating-badge top">
            <i className="fas fa-chart-line"></i>
            <span>3x ROI Growth</span>
          </div>

          <div className="floating-badge bottom">
            <i className="fas fa-shield-alt"></i>
            <span>Secure &amp; Scalable</span>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Hero;
